export default "__VITE_ASSET__DOx_eHV7__"